import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { styled } from '@styledComponents';
import { themeSpace, themeMediaQuery, themeColor } from '@utils/styledTheme.util';

export const StyledSection = styled(Box)`
  position: relative;
  z-index: 1;
  width: 100%;
  padding: ${themeSpace(8)};
  padding-top: ${themeSpace(0)};
  ${themeMediaQuery('sm')} {
    padding: 0 168px ${themeSpace(8)} 120px;
  }
`;

export const ItemWrapper = styled(Box)`
  padding: ${themeSpace(4)} 0;
`;

export const TextContentWrapper = styled(Box)<{ isExpanded: boolean }>`
  width: 100%;
  max-height: ${props => (props.isExpanded ? 'auto' : '215px')};
  overflow: ${props => (props.isExpanded ? 'auto' : 'hidden')};
  ${themeMediaQuery('below_sm')} {
    max-height: ${props => (props.isExpanded ? 'auto' : '234px')};
  }
`;

export const StyledTitleText = styled(Text)`
  font-weight: bold;
  padding-bottom: ${themeSpace(2)};
  font-size: ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    font-size: 14px;
  }
`;

export const StyledContentText = styled(Text)`
  font-size: 14px;
  ${themeMediaQuery('below_sm')} {
    font-size: ${themeSpace(4)};
  }
  line-height: ${themeSpace(5)};
  li {
    margin-top: ${themeSpace(1)};
  }
`;

export const StyledReadMore = styled(Flex)`
  span {
    font-size: 14px;
    ${themeMediaQuery('below_sm')} {
      font-size: ${themeSpace(4)};
    }
  }
  gap: ${themeSpace(1)};
  margin-top: ${themeSpace(3)};
  align-items: center;
  cursor: pointer;
`;
